<template>
  <img
    src="@/assets/images/gifs/flash.gif"
    alt="flash"
  >
</template>